export let url = 'https://alga.by/fitness_panel/api';

if (process.env.NODE_ENV === 'development') {
    url = 'https://alga.by/test_fitness_panel/api';
}
export const site = 'https://alga.by/';